import { render, staticRenderFns } from "./IconZap.vue?vue&type=template&id=6f89129c&scoped=true&"
import script from "./IconZap.vue?vue&type=script&lang=js&"
export * from "./IconZap.vue?vue&type=script&lang=js&"
import style0 from "./IconZap.vue?vue&type=style&index=0&id=6f89129c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89129c",
  null
  
)

export default component.exports